import classNames from "classnames";
import { ReactElement } from "react";
import { PrimaryButtonColor } from "../Button/Button";
import { Icon, IconValue } from "../Icon/Icon";
import { iconButtonKindToStyles } from "./common";
import { IconButtonKind, IconButtonSize } from "./IconButton";
import styles from "./IconButton.module.less";

export type IconButtonRendererProps = {
	kind: IconButtonKind;
	size: IconButtonSize;
	icon: IconValue;
	attachedOnClassNames: string;
} &
	(
		{ kind: Exclude<IconButtonKind, "primary">; }
		|
		{ kind: "primary"; color?: PrimaryButtonColor; }
	);

export const IconButtonRenderer = (props: IconButtonRendererProps): ReactElement => {
	const {
		kind,
		size,
		icon,
		attachedOnClassNames
	} = props;

	const color: PrimaryButtonColor | undefined = props.kind === "primary"
		? props.color ?? "primary"
		: undefined;

	return (
		<span
			className={classNames(
				styles.render,
				iconButtonKindToStyles[kind],
				color && colorToStyleMap[color],
				attachedOnClassNames
			)}
		>
			<Icon
				value={icon}
				size={size === "large" ? "large" : "medium"}
			/>
		</span>
	);
};
IconButtonRenderer.displayName = "IconButtonRenderer";

const colorToStyleMap: Record<PrimaryButtonColor, string> = {
	["primary"]: styles.render_primary,
	["header"]: styles.render_header,
	["app"]: styles.render_app,
	["info"]: styles.render_info,
	["success"]: styles.render_success,
	["warning"]: styles.render_warning,
	["danger"]: styles.render_danger,
	["bookmark"]: styles.render_bookmark
};
